import React from 'react';
import BannerSectionStyle9 from '../Section/BannerSection/BannerSectionStyle9';
import Section from '../Section';
import BlogSectionStyle2 from '../Section/BlogSection/BlogSectionStyle2';
import Breadcrumb from '../Breadcrumb';
import { pageTitle } from '../../helpers/PageTitle';
import { COMPANY_WHATSAPP } from '../../constants/brand';
const blogData = [
  {
    id: 'kerala-the-ultimate-destination-for-world-class-medical-tourism',
    title: 'Kerala: The Ultimate Destination for World-Class Medical Tourism',
    thumbUrl: "/images/blog/1.jpg",
    date: 'Feb 19, 2025',
    btnText: 'Learn More',
    href: '/blog/kerala-the-ultimate-destination-for-world-class-medical-tourism',
    socialShare: false,
  },
  {
    id: 'ayurveda-holistic-healing-why-tourists-choose-kerala-for-wellness',
    title: 'Ayurveda & Holistic Healing: Why Tourists Choose Kerala for Wellness',
    thumbUrl: "/images/blog/2.jpg",
    date: 'Feb 19, 2025',
    btnText: 'Learn More',
    href: '/blog/ayurveda-holistic-healing-why-tourists-choose-kerala-for-wellness',
    socialShare: false,
  },
  {
    id: 'a-complete-guide-to-medical-travel-in-kerala-what-to-expect',
    title: 'A Complete Guide to Medical Travel in Kerala: What to Expect',
    thumbUrl: "/images/blog/3.jpg",
    date: 'Feb 19, 2025',
    btnText: 'Learn More',
    href: '/blog/a-complete-guide-to-medical-travel-in-kerala-what-to-expect',
    socialShare: false,
  },
];

export default function Blog() {
  pageTitle('Blog');
  return (
    <>
      <Section topMd={170} bottomMd={20} bottomLg={20} topSm={100} bottomSm={20}>
        <Breadcrumb title="Blogs" />
      </Section>
      <Section bottomMd={20} bottomLg={20} bottomXl={20} topSm={20} bottomSm={20}>
        <BlogSectionStyle2 data={blogData} />
      </Section>
      <Section className="cs_footer_margin_0" topMd={20} topSm={20}>
        <BannerSectionStyle9
          title="Don’t Let Your Health <br />Take a Backseat!"
          subTitle="Schedule an appointment with one of our experienced <br />medical professionals today!"
          imgUrl="/images/doctors/consult.png"
          btnText="Chat With Us"
          btnUrl={COMPANY_WHATSAPP}
        />
      </Section>
    </>
  );
}
